module.exports = __webpack_public_path__ + "static/media/nojefehogar.56775d8f.png";